import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultArticlesContent: PageTypeContentModule = {
  pageTypeSlug: "articles-blogs",
  suggestedTitles: ["Getting Started Guide", "How-To Articles", "Industry Insights", "Latest News"],
  suggestedSlugs: ["getting-started", "how-to", "industry-news", "latest-updates"],
  description: "Blog posts, articles, and news content",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "Article Title", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "Write a compelling introduction that captures the reader's attention and provides context for the article.",
        },
      },
      {
        type: "header",
        data: { text: "Main Section", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "Develop your main points here. Break down complex topics into digestible sections with clear headings.",
        },
      },
      {
        type: "header",
        data: { text: "Key Takeaways", level: 2 },
      },
      {
        type: "list",
        data: {
          style: "unordered",
          items: ["First important point", "Second key insight", "Third main takeaway"],
        },
      },
      {
        type: "header",
        data: { text: "Conclusion", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "Summarize the main points and provide a call to action or next steps for the reader.",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
